/* eslint-disable no-undef */

import React from 'react';
import { ActivityIndicator, View, Text } from 'react-native';
import { getResponsiveStyle } from '../utils/appUtils';
import styles from './styles/style';
class loader extends React.Component {
  componentWillReceiveProps(nProps) {
    if (nProps.loading !== undefined) {
      if (nProps.loading) {
        window.addEventListener('keydown', this.handleKeyPress);
      } else {
        window.removeEventListener('keydown', this.handleKeyPress);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyPress);
  }

  handleKeyPress = event => {
    if (event.keyCode === 9) {
      event.preventDefault();
    }
  };

  render() {
    var props = this.props;
    const { measure } = props;
    if (props.loading) {
      return (
        <View
          style={[
            styles.modelStyle11,
            styles[getResponsiveStyle('modelStyle11', measure)]
          ]}
        >
          <View
            style={[
              styles.loadermain,
              styles[getResponsiveStyle('loadermain', measure)]
            ]}
          >
            <View
              style={[
                styles.loadingView,
                styles[getResponsiveStyle('loadingView', measure)]
              ]}
            >
              <ActivityIndicator animating size='large' color='white' />
              {props.valueloader === true ? (
                <View>
                  <Text
                    style={{
                      fontSize: 14,
                      fontFamily: 'Mulish',
                      color: 'white',
                      fontWeight: '700',
                      textAlign: 'center'
                    }}
                  >
                    Minions are hard at work on your masterpiece they appreciate
                    your patience
                  </Text>
                </View>
              ) : null}
              {props.message && (
                <View>
                  <Text
                    style={{
                      marginTop: 10,
                      fontSize: 16,
                      textAlign: 'center',
                      fontFamily: 'Mulish',
                      color: 'white',
                      fontWeight: '700'
                    }}
                  >
                    {props.message}
                  </Text>
                </View>
              )}
            </View>
          </View>
        </View>
      );
    } else {
      return <View></View>;
    }
  }
}

export default loader;
